import React, { useEffect, useRef, useState } from 'react'
import { ChevronLeft, Copy, Edit, Link2, Lock, Trash2, X } from 'lucide-react';
import { useUserContext } from '../contexts/user';
import { usePopUpContext } from '../contexts/Popup';
import { useNavigate } from 'react-router-dom';
import { usePreviewContext } from '../contexts/Preview';
import { useLoaderContext } from '../contexts/loader';
import { useQuizzesContext } from '../contexts/Quizzes';
import isArabic from 'is-arabic';
import { useCheckForNewToken } from '../checkForNewToken';

const CreateQuiz = () => {
  const navigate = useNavigate();

  const { checkForNewToken } = useCheckForNewToken();

  const [switchOn, setSwitchOn] = useState(localStorage.getItem("auto save") === "on" ? true : (!localStorage.getItem("auto save") ? true : false));
  const [questions, setQuestions] = useState(switchOn ? (localStorage.getItem("questions") ? JSON.parse(localStorage.getItem("questions")) : []) : []);
  const [teacherData, setTeacherData] = useState(localStorage.getItem("teacher data") ? JSON.parse(localStorage.getItem("teacher data")) : { gender: "", category: "", });
  const [description, setDescription] = useState(localStorage.getItem("description") || "");
  const [password, setPassword] = useState(localStorage.getItem("password") || "");
  const [showConfirmMessage, setShowConfirmMessage] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [isUpdating, setIsUpdating] = useState(-1);

  const { userInfo, userJWT, setUserJWT, setUserInfo, setUserIndex, setUser, appLanguage } = useUserContext();
  const { setMessageContent, setCopyLink } = usePopUpContext();
  const { setPreviewQuestions } = usePreviewContext();
  const { setIsLoading } = useLoaderContext();
  const { setQuizzes } = useQuizzesContext();

  const questionInput = useRef();
  const correctAnswer = useRef();
  const wrongAnswer1 = useRef();
  const wrongAnswer2 = useRef();
  const wrongAnswer3 = useRef();
  const questionsContainer = useRef();
  const descriptionInput = useRef();
  const passwordInput = useRef();

  const emptyInputs = () => {
    questionInput.current.value = "";
    correctAnswer.current.value = "";
    wrongAnswer1.current.value = "";
    wrongAnswer2.current.value = "";
    wrongAnswer3.current.value = "";
    questionInput.current.dir = "ltr";
    correctAnswer.current.dir = "ltr";
    wrongAnswer1.current.dir = "ltr";
    wrongAnswer2.current.dir = "ltr";
    wrongAnswer3.current.dir = "ltr";
  }

  useEffect(() => {
    if (userInfo.role === "student") {
      setIsStudent(true);
    } else {
      setIsStudent(false);
      setTeacherData({ gender: teacherData.gender === "" ? (!userInfo.username ? "" : "Mr." + userInfo.username) : teacherData.gender, category: teacherData.category === "" ? "Arabic" : teacherData.category, })
    }
  }, [userInfo])

  const addQuestion = () => {
    if (questionInput.current && correctAnswer.current && wrongAnswer1.current && wrongAnswer2.current && wrongAnswer3.current) {
      if (questionInput.current.value.trim() && correctAnswer.current.value.trim() && wrongAnswer1.current.value.trim() && wrongAnswer2.current.value.trim() && wrongAnswer3.current.value.trim()) {
        const values = [correctAnswer.current.value.trim(), wrongAnswer1.current.value.trim(), wrongAnswer2.current.value.trim(), wrongAnswer3.current.value.trim()];
        let haveDublicates = false;
        for (let i = 0; i < values.length; i++) {
          for (let j = 0; j < values.length; j++) {
            if (i !== j && values[i] === values[j]) {
              haveDublicates = true;
            }
          }
        }
        if (haveDublicates) {
          setMessageContent({
            title: appLanguage === "ar" ? "تم العثور على تكرارات" : "Found Duplicates",
            message: appLanguage === "ar" ? "يوجد مدخلان أو أكثر لهما نفس القيمة. يرجى تغييرها بحيث تكون جميع المدخلات فريدة." : "Two or more inputs have the same value. Please change them so all inputs are unique.",
          });
        } else {
          const questionData = {
            question: questionInput.current.value,
            answers: [correctAnswer.current.value, wrongAnswer1.current.value, wrongAnswer2.current.value, wrongAnswer3.current.value],
            correctAnswer: correctAnswer.current.value,
          };
          setQuestions(prev => ([
            ...prev, questionData
          ]))
          emptyInputs();
          if (switchOn) {
            localStorage.setItem("questions", JSON.stringify([...questions, questionData]));
          }
        }
      } else {
        setMessageContent({
          title: appLanguage === "ar" ? "حقل (حقول) مفقود" : "Missing Field(s)",
          message: appLanguage === "ar" ? "جميع الحقول مطلوبة لإضافة سؤالك." : "All fields are required for adding your question.",
        })
      }
    }
  }

  useEffect(() => {
    if (isUpdating !== -1) {
      const question = questions[isUpdating];
      questionInput.current.value = question.question;
      correctAnswer.current.value = question.answers[0];
      wrongAnswer1.current.value = question.answers[1];
      wrongAnswer2.current.value = question.answers[2];
      wrongAnswer3.current.value = question.answers[3];
    }
  }, [isUpdating])

  const updateQuestion = () => {
    if (questionInput.current && correctAnswer.current && wrongAnswer1.current && wrongAnswer2.current && wrongAnswer3.current) {
      if (questionInput.current.value.trim() && correctAnswer.current.value.trim() && wrongAnswer1.current.value.trim() && wrongAnswer2.current.value.trim() && wrongAnswer3.current.value.trim()) {
        const values = [correctAnswer.current.value.trim(), wrongAnswer1.current.value.trim(), wrongAnswer2.current.value.trim(), wrongAnswer3.current.value.trim()];
        let haveDublicates = false;
        for (let i = 0; i < values.length; i++) {
          for (let j = 0; j < values.length; j++) {
            if (i !== j && values[i] === values[j]) {
              haveDublicates = true;
            }
          }
        }
        if (haveDublicates) {
          setMessageContent({
            title: appLanguage === "ar" ? "تم العثور على تكرارات" : "Found Duplicates",
            message: appLanguage === "ar" ? "يوجد مدخلان أو أكثر لهما نفس القيمة. يرجى تغييرها بحيث تكون جميع المدخلات فريدة." : "Two or more inputs have the same value. Please change them so all inputs are unique.",
          });
        } else {
          const questionData = {
            question: questionInput.current.value,
            answers: [correctAnswer.current.value, wrongAnswer1.current.value, wrongAnswer2.current.value, wrongAnswer3.current.value],
            correctAnswer: correctAnswer.current.value,
          };
          const newQuestions = questions.map((question, i) => {
            if (i === isUpdating) {
              return questionData;
            } else {
              return question;
            }
          })
          setQuestions(newQuestions);
          if (switchOn) {
            localStorage.setItem("questions", JSON.stringify(newQuestions));
          }
          setIsUpdating(-1);
          emptyInputs();
        }
      } else {
        setMessageContent({
          title: appLanguage === "ar" ? "حقل (حقول) مفقود" : "Missing Field(s)",
          message: appLanguage === "ar" ? "جميع الحقول مطلوبة لإضافة سؤالك." : "All fields are required for adding your question.",
        })
      }
    }
  }

  const deleteQuestion = (i) => {
    const newQuestions = [...questions];
    newQuestions.splice(i, 1);
    setQuestions(newQuestions);
    if (switchOn) {
      localStorage.setItem("questions", JSON.stringify(newQuestions))
    }
  }

  const publishQuiz = () => {
    const quiz = {
      category: teacherData.category,
      from_id: userInfo.id,
      from_name: teacherData.gender,
      questions: questions,
      description: descriptionInput.current.value,
      password: passwordInput.current.value,
    };

    if (questions.length > 2) {
      setIsLoading(prev => prev + 1);
      fetch("https://quiz-battle-api.vercel.app/api/quiz", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${userJWT}`,
        },
        body: JSON.stringify(quiz),
      }).then(res => res.json())
        .then(data => {
          checkForNewToken(data, setUserJWT, setUserInfo, setUser, setUserIndex, navigate, setMessageContent);
          if (data.saved) {
            quiz._id = data.id;
            setMessageContent({ title: appLanguage === "ar" ? "تم نشر الاختبار" : "Quiz Published", message: appLanguage === "ar" ? "تم نشر الاختبار بنجاح." : "Quiz Published Successfully.", })
            setCopyLink(window.location.origin + "/info/" + data.id);
            localStorage.removeItem("questions");
            setQuizzes(prev => ([quiz, ...prev]));
            setPreviewQuestions([]);
            navigate("/home");
            localStorage.removeItem("description");
          } else {
            setMessageContent({ title: appLanguage === "ar" ? "فشل النشر" : "Publishing Failed", message: data.msg, })
          }
          setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
        }).catch(err => {
          console.log(err);
          setIsLoading(prev => prev !== 0 ? prev - 1 : prev);

          setMessageContent({ title: appLanguage === "ar" ? "خطأ في إنشاء الاختبار" : "Quiz Creation Error", message: appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء نشر الاختبار الخاص بك." : "Oops! something went wrong while publishing your quiz.", })
        })
    } else {
      setMessageContent({ title: appLanguage === "ar" ? "خطأ في عدد الأسئلة" : "Questions Number Error", message: appLanguage === "ar" ? "عذراً، يجب أن يحتوي الاختبار على 3 أسئلة على الأقل." : "Sorry, your quiz must contain at least 3 questions.", })
    }
  }

  return (
    <div className="create_quiz_container">
      <header>
        <ChevronLeft onClick={() => navigate("/home")} />
        <p>{appLanguage === "ar" ? "إنشاء اختبار" : "Create Quiz"}</p>
      </header>
      {!isStudent ?
        <>
          <div className="auto_save_questions">
            <p>{appLanguage === "ar" ? "حفظ تلقائي للأسئلة" : "Auto Save Questions"}</p>
            <div onClick={() => { setSwitchOn(!switchOn); localStorage.setItem("auto save", !switchOn ? "on" : "off") }} className={"switch " + (switchOn ? "on" : "off")}>
              <div className="slider"></div>
            </div>
          </div>
          <div className="quiz_data">
            <div className="title">{appLanguage === "ar" ? "بيانات الاختبار" : "Quiz Metadata"}</div>
            <div className="metadata">
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "اسم المعلم (السيد أو السيدة)" : "Teacher Name (Mr or Mrs)"}</p>
                <div className="field">
                  <select value={teacherData.gender} onChange={(e) => { setTeacherData(prev => ({ ...prev, gender: e.target.value, })); localStorage.setItem("teacher data", JSON.stringify({ ...teacherData, gender: e.target.value, })) }} id="field">
                    <option value={"Mr." + userInfo.username}>{"Mr." + userInfo.username}</option>
                    <option value={"Mrs." + userInfo.username}>{"Mrs." + userInfo.username}</option>
                  </select>
                </div>
              </div>
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "الفئة (المادة)" : "Category (Subject)"}</p>
                <div className="field">
                  <select value={teacherData.category} onChange={(e) => { setTeacherData(prev => ({ ...prev, category: e.target.value, })); localStorage.setItem("teacher data", JSON.stringify({ ...teacherData, category: e.target.value, })) }} name="category" id="field">
                    <option value="Math" >Math</option>
                    <option value="Arabic">Arabic</option>
                    <option value="English">English</option>
                    <option value="Science">Science</option>
                    <option value="French">French</option>
                    <option value="Social Studies">Social Studies</option>
                  </select>
                </div>
              </div>
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "الوصف (اختياري)" : "Description (Optional)"}</p>
                <textarea value={description} onChange={(e) => { localStorage.setItem("description", e.target.value); setDescription(e.target.value) }} ref={descriptionInput} name="description" id="description" placeholder={appLanguage === "ar" ? "اكتب وصفاً للاختبار الخاص بك..." : "Wirte a description for your quiz...."}></textarea>
              </div>
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "كلمة مرور الاختبار (اختياري)" : "Quiz Password (Optional)"}</p>
                <input value={password} onChange={(e) => { localStorage.setItem("password", e.target.value); setPassword(e.target.value) }} ref={passwordInput} type="text" name="password" id="password" placeholder={appLanguage === "ar" ? "أدخل كلمة مرور الاختبار..." : "Enter Quiz Password..."} />
              </div>
            </div>
          </div>
          <div className="add_question" ref={questionsContainer}>
            <div className="title" >{isUpdating !== -1 ? (appLanguage === "ar" ? "تحديث" : "Update") : (appLanguage === "ar" ? "جديد" : "New")} {appLanguage === "ar" ? "سؤال" : "Question"}</div>
            <div className="add_question_content">
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "السؤال" : "Question"}</p>
                <input
                  onChange={
                    (e) => {
                      if (e.target.value.trim() !== "" && isArabic(e.target.value.split(" ")[0], { count: 0, })) {
                        e.target.dir = "rtl";
                      } else {
                        e.target.dir = "ltr";
                      }
                    }} ref={questionInput} type="text" placeholder={appLanguage === "ar" ? "السؤال" : "Question"} />
              </div>
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "الإجابة الصحيحة" : "Correct Answer"}</p>
                <input onChange={
                  (e) => {
                    if (e.target.value.trim() && isArabic(e.target.value.split(" ")[0], { count: 0, })) {
                      e.target.dir = "rtl";
                    } else {
                      e.target.dir = "ltr";
                    }
                  }} ref={correctAnswer} type="text" placeholder={appLanguage === "ar" ? "الإجابة الصحيحة" : "Correct Answer"} />
              </div>
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "الإجابة الخاطئة 1" : "Wrong Answer 1"}</p>
                <input onChange={
                  (e) => {
                    if (e.target.value.trim() && isArabic(e.target.value.split(" ")[0], { count: 0, })) {
                      e.target.dir = "rtl";
                    } else {
                      e.target.dir = "ltr";
                    }
                  }} ref={wrongAnswer1} type="text" placeholder={appLanguage === "ar" ? "الإجابة الخاطئة 1" : "Wrong Answer 1"} />
              </div>
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "الإجابة الخاطئة 2" : "Wrong Answer 2"}</p>
                <input onChange={
                  (e) => {
                    if (e.target.value.trim() && isArabic(e.target.value.split(" ")[0], { count: 0, })) {
                      e.target.dir = "rtl";
                    } else {
                      e.target.dir = "ltr";
                    }
                  }} ref={wrongAnswer2} type="text" placeholder={appLanguage === "ar" ? "الإجابة الخاطئة 2" : "Wrong Answer 2"} />
              </div>
              <div className="input_field">
                <p className="field_title">{appLanguage === "ar" ? "الإجابة الخاطئة 3" : "Wrong Answer 3"}</p>
                <input onChange={
                  (e) => {
                    if (e.target.value.trim() && isArabic(e.target.value.split(" ")[0], { count: 0, })) {
                      e.target.dir = "rtl";
                    } else {
                      e.target.dir = "ltr";
                    }
                  }} ref={wrongAnswer3} type="text" placeholder={appLanguage === "ar" ? "الإجابة الخاطئة 3" : "Wrong Answer 3"} />
              </div>
            </div>
            <button id="add_question" className={isUpdating !== -1 ? "updating" : ""} onClick={() => isUpdating !== -1 ? updateQuestion() : addQuestion()}>{isUpdating !== -1 ? (appLanguage === "ar" ? "تحديث السؤال" : "Update Question") : (appLanguage === "ar" ? "إضافة السؤال" : "Add Question")}</button>
          </div>
          <div className="questions_container">
            <div className="title">{appLanguage === "ar" ? "الأسئلة" : "Questions"} ({questions.length})</div>
            <div className="questions">
              {
                questions.length ?
                  questions.map((question, i) => {
                    return (
                      <div key={"question_" + i} className={"question " + (questions.length === 1 ? "radius" : "")}>
                        <p dir={isArabic(question.question.split(" ")[0], { count: 0, }) ? "rtl" : "ltr"}>{question.question}</p>
                        <div className="buttons">
                          <button id="update" onClick={() => { questionsContainer.current.scrollIntoView({ behavior: "smooth", block: "start" }); setIsUpdating(i) }}><Edit size={18} /></button>
                          <button id="delete" onClick={() => { window.confirm(appLanguage === "ar" ? "هل أنت متأكد أنك تريد حذف هذا السؤال؟" : "Are you sure that you want to delete this question?") ? deleteQuestion(i) : console.log("Deleting question canceled.") }}><Trash2 size={18} /></button>
                        </div>
                      </div>
                    )
                  })
                  : <p className="no_quizzes">{appLanguage === "ar" ? "لم تتم إضافة أسئلة بعد." : "There are no questions added yet."}</p>
              }
            </div>
          </div>
          <div className="main_buttons">
            <button id="preview_quiz" onClick={() => { setPreviewQuestions(questions); navigate("/preview") }}>{appLanguage === "ar" ? "معاينة الاختبار" : "Preview Quiz"}</button>
            <button id="publish_quiz" onClick={() => setShowConfirmMessage(true)}>{appLanguage === "ar" ? "نشر الاختبار" : "Publish Quiz"}</button>
          </div>
        </> : <div className="no_access"><Lock size={50} /> <p>{appLanguage === "ar" ? "يسمح للمعلمين فقط بالوصول إلى هذه الصفحة. لن يتمكن الآخرون من عرض محتواها." : "Only teachers are allowed to access this page. Others won't be able to view its content."}</p></div>}
      {showConfirmMessage ? <PublishingConfirming appLanguage={appLanguage} publishQuiz={publishQuiz} setShowConfirmMessage={setShowConfirmMessage} /> : undefined}
    </div>
  )
}

const PublishingConfirming = ({ publishQuiz, setShowConfirmMessage, appLanguage }) => {
  return (
    <div className="confirm_message">
      <div className="content">
        <p>{appLanguage === "ar" ? "هل أنت متأكد أنك جاهز لنشر الاختبار، أم تريد التحقق منه أولاً؟" : "Are you sure you're ready to publish your quiz, or do you want to double-check it first?"}</p>
        <div className="buttons">
          <button id="publish" onClick={publishQuiz}>{appLanguage === "ar" ? "نشر" : "Publish"}</button>
          <button id="check" onClick={() => setShowConfirmMessage(false)}>{appLanguage === "ar" ? "تحقق مزدوج" : "Double Check"}</button>
        </div>
      </div>
    </div>
  );
}

export default CreateQuiz;